import type { ReactElement } from 'react';

import { SectionWrap } from '../SectionWrap/SectionWrap';
import { Stats } from '../Stats/Stats';
import { Story } from '../Story/Story';
import { Grid } from './StatsStory.styled';

export const StatsStory = (): ReactElement => (
  <SectionWrap>
    <Grid>
      <Stats />
      <Story />
    </Grid>
  </SectionWrap>
);
